import api from '../technique/api';

export interface IComptant {
  simulationId: string;
  typeContrat: string;
  montant: number;
  typePayment: number;
  numeroPolice?: string | null;
  primeTTC: number;
}

export const ComptantBDL = () => ({
  postComptant: async (data: IComptant) =>
    await api.post('payment/comptant/numero', data),
});
